import { render } from "./SectionHeaderPreview.vue?vue&type=template&id=6649b54e&scoped=true"
import script from "./SectionHeaderPreview.vue?vue&type=script&lang=js"
export * from "./SectionHeaderPreview.vue?vue&type=script&lang=js"

import "./SectionHeaderPreview.vue?vue&type=style&index=0&id=6649b54e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6649b54e"]])

export default __exports__